import React from 'react'
import '../../assets/scss/elements/_sticky.scss'


const StickyContainer = ({ children }) => (
    <div className="sticky-container">{children}</div>
  )

export default StickyContainer
